export const productType = (p) => (p.members_only ? "Pack" : p.kind === "pack" ? "2-Pack" : (p.contents?.length || 0) > 1 ? "Stack" : "Single");

export const TypeBadge = ({ p, className = "" }) => (
  <span data-testid={`type-badge-${p.id}`} className={`inline-block rounded-full border border-navy/30 bg-sand px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-[0.12em] text-navy ${className}`}>{productType(p)}</span>
);

export const Contains = ({ p }) => productType(p) === "Single" ? null : (
  <div data-testid={`contains-${p.id}`} className="mt-3 text-sm text-slate-700">
    <p className="font-semibold">Contains:</p>
    <ul className="mt-1 list-disc pl-5 space-y-0.5">{p.contents.map((c) => <li key={c}>{c}</li>)}</ul>
  </div>
);
